import { Box, Button, HStack, Text } from '@chakra-ui/react';

export type ActiveTrack = 'optimize' | 'explore';

interface TrackToggleProps {
  activeTrack: ActiveTrack;
  onTrackChange: (track: ActiveTrack) => void;
}

export const TrackToggle = ({
  activeTrack,
  onTrackChange,
}: TrackToggleProps) => (
  <Box
    bg="white"
    borderRadius="xl"
    p={1.5}
    border="1px solid"
    borderColor="silver.500"
    boxShadow="0 1px 6px rgba(45, 66, 106, 0.06)"
  >
    <HStack spacing={1}>
      <Button
        flex="1"
        size="md"
        borderRadius="lg"
        variant="unstyled"
        bg={activeTrack === 'optimize' ? 'navyBlue.500' : 'transparent'}
        color={activeTrack === 'optimize' ? 'white' : 'navyBlue.400'}
        _hover={{
          bg: activeTrack === 'optimize' ? 'navyBlue.600' : 'navyBlue.50',
        }}
        onClick={() => onTrackChange('optimize')}
        py={3}
        px={4}
        h="auto"
        transition="all 0.15s ease-in-out"
      >
        <Box textAlign="center">
          <Text
            fontSize="sm"
            fontWeight="bold"
            color={activeTrack === 'optimize' ? 'white' : 'navyBlue.500'}
          >
            Optimize Current Path
          </Text>
          <Text
            fontSize="xs"
            fontWeight="normal"
            color={activeTrack === 'optimize' ? 'navyBlue.200' : 'navyBlue.300'}
            mt={0.5}
          >
            Maximize earnings in your current role
          </Text>
        </Box>
      </Button>

      <Button
        flex="1"
        size="md"
        borderRadius="lg"
        variant="unstyled"
        bg={activeTrack === 'explore' ? 'green.500' : 'transparent'}
        color={activeTrack === 'explore' ? 'white' : 'navyBlue.400'}
        _hover={{
          bg: activeTrack === 'explore' ? 'green.600' : 'navyBlue.50',
        }}
        onClick={() => onTrackChange('explore')}
        py={3}
        px={4}
        h="auto"
        transition="all 0.15s ease-in-out"
      >
        <Box textAlign="center">
          <Text
            fontSize="sm"
            fontWeight="bold"
            color={activeTrack === 'explore' ? 'white' : 'navyBlue.500'}
          >
            Explore New Directions
          </Text>
          <Text
            fontSize="xs"
            fontWeight="normal"
            color={activeTrack === 'explore' ? 'green.100' : 'navyBlue.300'}
            mt={0.5}
          >
            Discover roles, employers &amp; locations
          </Text>
        </Box>
      </Button>
    </HStack>
  </Box>
);
